import styled from 'styled-components';
import Box from '../../components/layout/Box';

import { useNavigate } from 'react-router-dom';
import Image from '../../components/Image';

const StyledBox = styled(Box)`
  display: none;

  @media (max-width: 768px) {
    display: flex;
  }
`;

const Logo = () => {
  const navigate = useNavigate();

  const handlePress = () => {
    navigate('/');
  };

  return (
    <StyledBox
      onClick={handlePress}
      className="h-100 align-items-center ms-2 me-1"
    >
      <Box className="justify-content-center">
        <Image
          style={{ width: 32, height: 'auto' }}
          source="https://kthbok-images.s3.eu-north-1.amazonaws.com/content/logo-small.png"
        />
      </Box>
    </StyledBox>
  );
};

export default Logo;
